module.exports = __webpack_public_path__ + "img/download-2-2INT.b1639280.png";